import React from "react";
import Card from "../modules/Products/Card";

export function ProductCardPage(props) {
  return (
    <Card {...props} />
  );
}
